import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./accountPrivacyPolicy.css";
import translations from "../../../translations/translations";

const COMPANY_NAME = "ReservaSinFila";
const CONTACT_EMAIL = "soporte@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

const renderParagraphs = (section) =>
    Object.keys(section || {})
        .filter((k) => k.startsWith("p"))
        .map((key) => <p key={key}>{section[key]?.replace("{{COMPANY_NAME}}", COMPANY_NAME)}</p>);

const AccountPrivacyPolicy = () => {
    const { language } = useContext(CombinedContext);
    const t = translations[language].privacy;

    return (
        <div className="privacy-page">
            <div className="privacy-container">
                {/* HEADER */}
                <header className="privacy-header">
                    <h1>{t.title}</h1>
                    <p className="privacy-updated">
                        {t.lastUpdated}: {LAST_UPDATED}
                    </p>
                </header>

                {/* INTRO */}
                <section className="privacy-section">{renderParagraphs(t.intro)}</section>

                {/* 1) INFORMATION WE COLLECT */}
                <section className="privacy-section">
                    <h2>{t.infoCollect.heading}</h2>

                    <h4>{t.infoCollect.provided}</h4>
                    <ul>
                        {t.infoCollect.providedList.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>

                    <h4>{t.infoCollect.automatic}</h4>
                    <ul>
                        {t.infoCollect.automaticList.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>

                    <h4>{t.infoCollect.thirdParty}</h4>
                    <ul>
                        {t.infoCollect.thirdPartyList.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                </section>

                {/* 2) HOW WE USE */}
                <section className="privacy-section">
                    <h2>{t.howWeUse.heading}</h2>
                    <ul>
                        {t.howWeUse.list.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                </section>

                {/* 3) SHARING */}
                <section className="privacy-section">
                    <h2>{t.sharing.heading}</h2>
                    <ul>
                        {t.sharing.list.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                    <p>{t.sharing.noSell}</p>
                </section>

                {/* 4) COOKIES */}
                <section className="privacy-section">
                    <h2>{t.cookies.heading}</h2>
                    <p>{t.cookies.text}</p>
                </section>

                {/* 5) SECURITY */}
                <section className="privacy-section">
                    <h2>{t.security.heading}</h2>
                    <p>{t.security.text}</p>
                </section>

                {/* 6) RETENTION */}
                <section className="privacy-section">
                    <h2>{t.retention.heading}</h2>
                    <p>{t.retention.text}</p>
                </section>

                {/* 7) INTERNATIONAL */}
                <section className="privacy-section">
                    <h2>{t.international.heading}</h2>
                    <p>{t.international.text}</p>
                </section>

                {/* 8) MINORS */}
                <section className="privacy-section">
                    <h2>{t.minors.heading}</h2>
                    {renderParagraphs(t.minors)}
                </section>

                {/* 9) USER CONTENT */}
                <section className="privacy-section">
                    <h2>{t.userContent.heading}</h2>
                    {renderParagraphs(t.userContent)}
                </section>

                {/* 10) PLATFORM LIABILITY */}
                <section className="privacy-section">
                    <h2>{t.platform.heading}</h2>
                    {renderParagraphs(t.platform)}
                </section>

                {/* 11) RIGHTS */}
                <section className="privacy-section">
                    <h2>{t.rights.heading}</h2>
                    <ul>
                        {t.rights.list.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                    <p>{t.rights.contact.replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL)}</p>
                </section>

                {/* 12) CHANGES */}
                <section className="privacy-section">
                    <h2>{t.changes.heading}</h2>
                    <p>{t.changes.text}</p>
                </section>

                {/* 13) CONTACT */}
                <section className="privacy-section">
                    <h2>{t.contact.heading}</h2>
                    <p>{t.contact.text.replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL)}</p>
                </section>
            </div>
        </div>
    );
};

export default AccountPrivacyPolicy;
